export default "__VITE_ASSET__CL7109h4__"